import { Button, Chip, Typography, Modal } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { TopToolbar, useDataProvider } from "react-admin";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../../firebase";
import {
  checkMachineDualMode,
  getEmployee,
  getEmployeeDocs,
  getErrorCategoryMessage,
  getFormattedSlotId,
  getProduct,
  getProductCategory,
  getProductCategoryDocs,
  getProductDocs,
  getPyamentType,
  //getStatus,
  productDetails,
  productType,
  renderDateMY,
  renderDateTime,
  renderTImeMY,
  renderTransactionStatus,
} from "../Employee/ValidateCSV";
import _extendLayout from "../../layout/_extendLayout";
import { FilterList as FilterListIcon } from "@mui/icons-material";
import axios from "axios";
import { Table } from "react-bootstrap";
import CustomizedDialogs from "./Sales/TransactionDetails";
import { makeStyles } from "@material-ui/core/styles";
import TransactionFilter from "../Filters/TransactionFilter";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import Paginations from "../Pagination";

const CustomActions = ({
  setShowTransactionFilter,
  tranExporter,
  totalAmount,
  appliedFilters,
  showExport = true,
}) => {
  const getLabel = (key, value) => {
    if (key === "Status") {
      return `Status: ${value}`;
    }
    if (key === "Machine UUID") {
      return `Machine UUID: ${value}`;
    }
    if (key === "Date") {
      return `Date: ${value}`;
    }
    return `${key}: ${value}`;
  };

  return (
    <TopToolbar
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        flexWrap: "wrap",
        gap: 12,
        width: "100%",
      }}
    >
      <div style={{ display: "flex", alignItems: "center" }}>
        <Typography variant="h6">
          Total Credit: {totalAmount.toFixed(2)}
        </Typography>
      </div>

      <div
        style={{
          display: "flex",
          alignItems: "center",
          flexWrap: "wrap",
          justifyContent: "flex-end",
          gap: 12,
        }}
      >
        {(appliedFilters || []).map((filter, index) =>
          filter?.value ? (
            <Chip
              key={index}
              label={getLabel(filter.key, filter.value)}
              color="primary"
            />
          ) : null,
        )}
        <Button
          startIcon={<FilterListIcon />}
          variant="outlined"
          color="primary"
          style={{ border: "none" }}
          onClick={() => setShowTransactionFilter(true)}
        >
          Show Filters
        </Button>
        {showExport && (
          <Button
            color="primary"
            startIcon={<FileDownloadIcon />}
            onClick={tranExporter}
          >
            Export
          </Button>
        )}
      </div>
    </TopToolbar>
  );
};

const TransactionList = (props) => {
  const dataProvider = useDataProvider();
  const classes = useStyles();

  const [isAdmin, setIsAdmin] = useState(false);
  const [clientId, setClientId] = useState(null);
  const [mroList, setMroList] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState(false);
  const [appliedFilters, setAppliedFilters] = useState([]);
  const [isDrawerOpen, setDrawerOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const [mroSortField, setMroSortField] = useState("Date");
  const [mroSortOrder, setMroSortOrder] = useState("DESC");
  const [mroPage, setMroPage] = useState(1);
  const [perPage] = useState(25);
  const [showTransactionFilter, setShowTransactionFilter] = useState(false);
  const [mroFilters, setMroFilters] = useState({});

  const handleFilteredData = (data) => {
    const formattedData = Array.isArray(data)
      ? data.map((item) => ({
          ...item,
          id: item.TrasactionId,
        }))
      : [];
    setFilteredData(formattedData);
    setMroList(formattedData);
  };

  useEffect(() => {
    const checkAuth = onAuthStateChanged(auth, async (user) => {
      if (user) {
        const { client, role } = await getCurrentUser(user.uid);

        setClientId(client);
        setIsAdmin(role);
      }
    });

    return () => checkAuth();
  }, []);

  const getCurrentUser = async (userId) => {
    try {
      const res = await dataProvider.getOne("users", { id: userId });
      const client = res.data?.client?.id;
      const role = res.data?.role === "admin";

      return { client, role };
    } catch (err) {
      console.log(err);
    }
  };

  const getMroTransList = async (filter = mroFilters, pagination, sort) => {
    setLoading(true);
    try {
      const token = localStorage.getItem("token");

      let skip = (pagination.page - 1) * pagination.perPage;
      let limit = pagination.perPage;

      let sortField = sort.field || "Date";
      let sortOrder = sort.order || "DESC";

      let params = {
        ...filter,
        skip,
        limit: limit,
        sortField: sortField,
        sortOrder: sortOrder,
      };

      params.mode = "mro";

      const res = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/machine_transaction/mroList`,
        {
          params,
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        },
      );

      const rawDatas = res.data.result.data;
      if (Array.isArray(rawDatas)) {
        const formattedData = rawDatas.map((item) => ({
          ...item,
          id: item.TransactionId,
        }));
        setFilteredData(formattedData);
        setMroList(formattedData);
        setTotal(res.data.result.total);
        setTotalAmount(
          formattedData.reduce(
            (sum, item) => sum + (parseFloat(item.Amount) || 0),
            0,
          ),
        );
      } else {
        console.error("Invalid data format:", rawDatas);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const tranExporter = async () => {
    try {
      const token = localStorage.getItem("token");

      const params = {
        ...mroFilters,
        skip: 0,
        limit: 3000,
        mode: "mro",
      };

      if (!isAdmin) {
        params.client = clientId;
      }

      const res = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/machine_transaction/mroList`,
        {
          params,
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        },
      );

      console.log(res.data, "mana Res Data saya di mana for export");

      const allData = res.data?.result?.data;
      if (isAdmin) {
        await generateCSV(allData);
      } else {
        const isMachineDualMode = await checkMachineDualMode(clientId);
        const employees = await getEmployeeDocs(clientId);
        const products = await getProductDocs(clientId);
        const categories = await getProductCategoryDocs(clientId);

        const enrichedData = await Promise.all(
          allData.map(async (post) => {
            post.time = renderTImeMY(post);
            post.date = renderDateMY(post);

            const { department, cardNumber } = getEmployee(post, employees);
            post.employee = {
              ...post.Employee,
              department,
              cardNumber,
            };

            const { sku, serialNumber } = getProduct(post, products);
            post.product = {
              ...post.Product,
              sku,
              serialNumber,
            };

            const formattedSlotId = getFormattedSlotId(post);
            post.product.formattedSlotId = formattedSlotId;

            const { category } = getProductCategory(post, categories);
            post.product.categoryName = category;

            if (post?.payment?.gatewayID) {
              post.payment.paymentGateway = "Ipay88";
              post.payment.ewalletType = getPyamentType(post);
            } else {
              post.payment = {
                ...post.payment,
                paymentGateway: getPyamentType(post),
              };
            }

            post.Status = post.Status;

            const { category: errorCategory, message } =
              getErrorCategoryMessage(post);
            post.error = {
              ...post.error,
              message,
            };
            return post;
          }),
        );

        await generateCSV(enrichedData, isMachineDualMode ? "dual" : "general");
      }
    } catch (error) {
      console.log(error);
    }
  };

  const generateCSV = async (data) => {
    // const headers = [
    //   "TransactionId",
    //   "Amount",
    //   "Date / Time",
    //   "Machine UUID",
    //   "Employee Type",
    //   "Employee Name",
    //   "Employee Card Number",
    //   "Product Category",
    //   "Product Name (Transaction)",
    //   "Product Name (Current)",
    //   "Product SKU",
    //   "Product Serial",
    //   "Slot",
    //   "Quantity",
    //   "Credit",
    //   "Employee Cost Center",
    //   "Employee Number",
    //   "Employee Params Tag",
    //   "Employee Params Value",
    //   "Product Price",
    //   "Response Status Data",
    //   "Response Status Extra Spin Enabled",
    //   "Response Status Global Dropped Sensor",
    //   "Response Status Item Dropped",
    //   "Response Status Item Dropped Sensor",
    //   "Response Status Locker Opened",
    //   "Response Status Motor Turned",
    //   "Response Status No Of Extra Spin",
    //   "Response Status No Of Item Dropped",
    //   "Employee Params",
    //   "Response Status YY Item Dropped",
    //   "Response Status YY Motor Response No Timed Out",
    //   "Response Status YY Motor Response Reset After Rotation",
    //   "Response Status YY Motor Response Reset Before Rotation",
    //   "Response Status YY Motor Response with Feedback Signal",
    // ];
    const headers = [
      "TransactionId",
      "Machine UUID",
      "mode",
      "Date / Time",
      "Product Name",
      "Amount",
      "Status",
      "Employee Credit",
      "Employee Card Number",
      "Employee Full Name",
      "Payment Currency",
      "Payment Type",
      "Product Price",
      "Product Slot Id",
      "Quantity",
      //"Employee Type",
      // "Employee Name",
      //"Product Category",
      //   "Product Name (Transaction)",
      //  "Product Name (Current)",
      //"Product SKU",
      // "Product Serial",
      //"Slot",
      //"Quantity",
      //"Credit",
      // "Employee Cost Center",
      // "Employee Number",
      //"Employee Params Tag",
      //"Employee Params Value",
      //"Product Price",
      //"Response Status Data",
      //"Response Status Extra Spin Enabled",
      //"Response Status Global Dropped Sensor",
      //"Response Status Item Dropped",
      //"Response Status Item Dropped Sensor",
      //  "Response Status Locker Opened",
      //  "Response Status Motor Turned",
      // "Response Status No Of Extra Spin",
      // "Response Status No Of Item Dropped",
      // "Employee Params",
      //  "Response Status YY Item Dropped",
      //  "Response Status YY Motor Response No Timed Out",
      //  "Response Status YY Motor Response Reset After Rotation",
      //  "Response Status YY Motor Response Reset Before Rotation",
      //  "Response Status YY Motor Response with Feedback Signal",
    ];

    const csvRows = [headers.join(",")];

    data.forEach((m) => {
      let parsedResponseStatus = {};
      try {
        parsedResponseStatus =
          typeof m.ResponseStatus === "string"
            ? JSON.parse(m.ResponseStatus)
            : m.ResponseStatus || {};
      } catch (err) {
        console.error("Invalid JSON in responseStatus", err);
        parsedResponseStatus = {};
      }

      const date = new Date(m.Date);
      const formattedDate = date.toLocaleString("en-US", {
        weekday: "short",
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      });
      const status = m.status ?? m.Status;

      const row = [
        m.TransactionId,
        m.Machine?.machineUUID ?? "",
        m.Mode ?? "",
        formattedDate,
        m.Product?.name ?? "",
        m.Amount ?? "",
        status === 1 ? "Success" : "Failed",
        m.Employee?.credit ?? "",
        m.Employee?.employeeNumber ?? "N/A",
        m.Employee?.fullName ?? "",
        "MYR",
        m.Payment?.paymentType ?? "",
        m.Product?.price ?? "",
        m.Product?.slotId ?? "N/A",
        m.Quantity ?? "",
        // `"${m.Employee?.fullName ?? ""}"`,
        // m.Employee?.cardNumber ?? "N/A",
        //  m.product?.categoryId ?? "",
        //m.productName ?? "N/A",
        //m.productDetail?.productSku ?? "N/A",
        //m.productDetail?.productSerial ?? "N/A",
        // m.Employee?.costCenter ?? "",
        // m.Employee?.employeeNumber ?? "",
        // (m.Employee?.params || []).map((p) => p.tag).join(", "),
        //  (m.Employee?.params || []).map((p) => p.value).join(", "),
        // parsedResponseStatus?.data ?? "N/A",
        // parsedResponseStatus?.extraSpinEnabled ?? "N/A",
        //parsedResponseStatus?.globalDroppedSensor ?? "N/A",
        //parsedResponseStatus?.itemDropped ?? "N/A",
        //parsedResponseStatus?.itemDroppedSensor ?? "N/A",
        // parsedResponseStatus?.lockerOpened ?? "N/A",
        //  parsedResponseStatus?.motorTurned ?? "N/A",
        //    parsedResponseStatus?.noOfExtraSpin ?? "N/A",
        //    parsedResponseStatus?.noOfItemDropped ?? "N/A",
        // (m.Employee?.params || [])
        //   .map((p) => `${p.tag}: ${p.value}`)
        //   .join(", "),
        //parsedResponseStatus?.yyItemDropped ?? "N/A",
        //parsedResponseStatus?.yyMotorResponse?.noTimedOut ?? "N/A",
        //parsedResponseStatus?.yyMotorResponse?.resetAfterRotation ?? "N/A",
        //parsedResponseStatus?.yyMotorResponse?.resetBeforeRotation ?? "N/A",
        // parsedResponseStatus?.yyMotorResponse?.witFeedbackSignal ?? "N/A",
      ];

      csvRows.push(
        row.map((value) => String(value ?? "").replaceAll(",", " ")).join(","),
      );
    });
    const machineUUID = [
      ...new Set(data.map((m) => m.Machine?.machineUUID).filter(Boolean)),
    ];
    const blob = new Blob([csvRows.join("\n")], {
      type: "text/csv;charset=utf-8",
    });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download =
      machineUUID.length === 1
        ? `${machineUUID[0]}.csv`
        : "MRO Transactions.csv";
    link.style.display = "none";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const renderAdminMoreButtonField = (record) => {
    let enrichedRecord = { ...record };

    try {
      if (typeof record.ResponseStatus === "string") {
        enrichedRecord.ResponseStatus = JSON.parse(record.ResponseStatus);
      }
    } catch (err) {
      console.log("Invalid JSON in ResponseStatus:", err);
    }

    return (
      <Button
        size="medium"
        onClick={() => {
          setModalOpen(true);
          setModalContent(JSON.stringify(enrichedRecord, null, 2));
        }}
      >
        &gt;
      </Button>
    );
  };

  const renderCustomerMoreButtonField = (record) => {
    return (
      <Button
        size="medium"
        onClick={() => {
          setModalContent(record);
          setModalOpen(true);
        }}
      >
        &gt;
      </Button>
    );
  };

  const handleSortChange = (field) => {
    setMroSortField(field);
    setMroSortOrder((prevSortOrder) => {
      const newOrder = prevSortOrder === "ASC" ? "DESC" : "ASC";
      return newOrder;
    });
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);

      let filter = isAdmin
        ? { mode: "mro" }
        : { client: clientId, mode: "mro" };

      await getMroTransList(
        mroFilters,
        { page: mroPage, perPage: perPage },
        { field: mroSortField, order: mroSortOrder },
      );
    };

    fetchData();
  }, [mroPage, mroSortField, mroSortOrder]);

  return (
    <>
      <_extendLayout
        isModalOpen={isDrawerOpen || showTransactionFilter || modalOpen}
      >
        <div style={{ width: "90%" }}>
          <h4>MRO Transaction List</h4>
          {loading ? (
            <Typography>Loading...</Typography>
          ) : mroList.length === 0 ? (
            <>
              <CustomActions
                totalAmount={totalAmount}
                appliedFilters={appliedFilters}
                tranExporter={() => tranExporter(filteredData)}
                setShowTransactionFilter={setShowTransactionFilter}
                showExport={false}
              />
              <Typography>
                No data found in this month. Please select a different date
                range in the filter.
              </Typography>
            </>
          ) : (
            <>
              <CustomActions
                totalAmount={totalAmount}
                appliedFilters={appliedFilters}
                onShowFilters={() => setModalOpen(true)}
                tranExporter={() => tranExporter(filteredData)}
                setFilteredData={setFilteredData}
                setAppliedFilters={setAppliedFilters}
                setShowTransactionFilter={setShowTransactionFilter}
                setIsLoading={setLoading}
                data={mroList}
              />
              <Table striped bordered hover responsive>
                <thead>
                  <tr>
                    <th
                      className="fixed-col-date"
                      onClick={() => handleSortChange("Date")}
                      style={{ cursor: "pointer" }}
                    >
                      Date/Time{" "}
                      {mroSortField === "Date" &&
                        (mroSortOrder === "ASC" ? "↑" : "↓")}
                    </th>
                    {isAdmin && <th>Company Name</th>}
                    <th
                      className="fixed-col-machine"
                      onClick={() => handleSortChange("Machine.machineUUID")}
                      style={{ cursor: "pointer" }}
                    >
                      Machine UUID{" "}
                      {mroSortField === "Machine.machineUUID" &&
                        (mroSortOrder === "ASC" ? "↑" : "↓")}
                    </th>
                    <th
                      className="fixed-col-name"
                      onClick={() => handleSortChange("Employee.fullName")}
                      style={{ cursor: "pointer" }}
                    >
                      Employee Name{" "}
                      {mroSortField === "Employee.fullName" &&
                        (mroSortOrder === "ASC" ? "↑" : "↓")}
                    </th>
                    <th className="fixed-col-dept">Department</th>
                    <th
                      className="fixed-col-product"
                      onClick={() => handleSortChange("Product.name")}
                      style={{ cursor: "pointer" }}
                    >
                      Product Name{" "}
                      {mroSortField === "Product.name" &&
                        (mroSortOrder === "ASC" ? "↑" : "↓")}
                    </th>
                    <th
                      className="fixed-col-price"
                      onClick={() => handleSortChange("Amount")}
                      style={{ cursor: "pointer" }}
                    >
                      Price (Cr/RM){" "}
                      {mroSortField === "Amount" &&
                        (mroSortOrder === "ASC" ? "↑" : "↓")}
                    </th>
                    <th className="fixed-col-status">Status</th>
                    <th className="fixed-col-actions"></th>
                  </tr>
                </thead>
                <tbody>
                  {filteredData.length === 0 ? (
                    <tr>
                      <td
                        colSpan={isAdmin ? 10 : 9}
                        style={{ textAlign: "center", padding: "1rem" }}
                      >
                        No data found
                      </td>
                    </tr>
                  ) : (
                    filteredData.map((item, index) => (
                      <tr key={index}>
                        <td>{renderDateTime(item)}</td>
                        {isAdmin && <td>{item.companyName}</td>}
                        <td>{item.Machine.machineUUID}</td>
                        <td>{item.Employee?.fullName}</td>
                        <td>{item.Employee !== null ? item.typeName : ""}</td>
                        <td>{item.Product?.name}</td>
                        <td className="fixed-col-price">{item.Amount}</td>
                        <td>{renderTransactionStatus(item)}</td>
                        <td>
                          {isAdmin
                            ? renderAdminMoreButtonField(item)
                            : renderCustomerMoreButtonField(item)}
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </Table>

              <div style={{ display: "flex", justifyContent: "flex-end" }}>
                <Paginations
                  total={total}
                  currentPage={mroPage}
                  perPage={25}
                  onPageChange={setMroPage}
                />
              </div>

              {modalOpen &&
                modalContent &&
                (isAdmin ? (
                  <Modal open={modalOpen} onClose={() => setModalOpen(false)}>
                    <div className={classes.paper}>
                      <pre
                        style={{
                          whiteSpace: "pre-wrap",
                          wordBreak: "break-word",
                        }}
                      >
                        {modalContent}
                      </pre>
                    </div>
                  </Modal>
                ) : (
                  <CustomizedDialogs
                    record={modalContent}
                    open={modalOpen}
                    onClose={() => setModalOpen(false)}
                  />
                ))}
            </>
          )}
        </div>

        {showTransactionFilter && (
          <TransactionFilter
            storageKey="transaction-list-filters"
            setFilteredData={handleFilteredData}
            allData={mroList}
            modalOpen={showTransactionFilter}
            onModalOpenChange={setShowTransactionFilter}
            setAppliedFilters={setAppliedFilters}
            setTotalAmount={setTotalAmount}
            setTotal={setTotal}
            setFilter={setMroFilters}
            setIsLoading={setLoading}
            sales={{ sales: false, module: "mro" }}
          />
        )}
      </_extendLayout>
    </>
  );
};

const useStyles = makeStyles((theme) => ({
  paper: {
    position: "fixed",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    maxWidth: 500,
    maxHeight: "90%",
    overflow: "scroll",
    backgroundColor: "#ffffff",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
}));

export default TransactionList;
